export default function removeTrailingSlash (url = ''): string {
    return url.replace(/(.*)\/$/, '$1');
}
